/*
 * 许可管理接口
 * */
import services from "../config/axios";
import base from './base';
// 定义参数类型
type paramsType<T> = {
  [key: string]: T;
};

const licenseManageAPI = {
  // 获取许可列表
  getLicenseList<T>(params: FormData) {
    return services.post(`${base.lk}/License/GetLicenseList`, params);
  },
  //许可审批
  getLicenseAudit<T>(params: FormData) {
    return services.post(`${base.lk}/License/GetLicenseAudit`, params);
  },
  // 新增许可
  addLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/AddLicense`, params);
  },
  // 更新许可
  updateLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/UpdateLicense`, params);
  },
  // 获取一个许可
  getOneLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/GetOneLicense`, params);
  },
  // 提交许可
  submitLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/SubmitLicense`, params);
  },
  // 审批许可
  auditLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/AuditLicense`, params);
  },
  // 删除许可
  delLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/DelLicense`, params);
  },
  //延期申请
  moreLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/MoreLicense`, params);
  },
  stopLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/StopLicense`, params);
  },
  startLicense<T>(params: FormData) {
    return services.post(`${base.lk}/License/StartLicense`, params);
  },
  getLicenseCount() {
    return services.post(`${base.lk}/License/GetLicenseCount`);
  },
};

export default licenseManageAPI;
